(() => {
  if (window.__pfJournalTracking) return;
  window.__pfJournalTracking = true;
  const article = document.querySelector('[data-pf-journal-article]');
  if (!article || window.Shopify?.theme?.role !== 'main') return;
  const privacyAllowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return typeof privacy?.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed();
  };
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || !article.contains(link)) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin !== location.origin || !destination.pathname.includes('/products/')) return;
    if (!privacyAllowed() || window.Shopify?.designMode || new URLSearchParams(location.search).has('preview_theme_id')) return;
    const payload = {
      article_handle: article.dataset.pfJournalArticle,
      article_path: article.dataset.pfJournalPath,
      product_handle: destination.pathname.split('/products/')[1].split('/')[0],
      destination_path: destination.pathname
    };
    const analytics = window.Shopify?.analytics;
    if (typeof analytics?.publish === 'function') {
      try { Promise.resolve(analytics.publish('pf_journal_product_click', payload)).catch(() => {}); } catch {}
    }
    if (typeof window.gtag === 'function') window.gtag('event', 'journal_product_click', { ...payload, transport_type: 'beacon' });
  });
})();
